// src/utils/seoDefaults.js
export const seoDefaults = {
  home: {
    title: "GameZtudio | Home of Gaming Legends",
    description: "Shop consoles, game CDs, and accessories with unbeatable prices.",
    image: "/images/home-banner.jpg",
  },
  contact: {
    title: "Contact GameZtudio",
    description: "Need help? Reach out to our friendly support team anytime.",
  },
  about: {
    title: "About GameZtudio",
    description: "Learn about our mission to deliver premium gaming products and experience.",
  },
  categories: {
    title: "Shop by Category | GameZtudio",
    description: "Browse our curated gaming collections by category.",
  },
  checkout: {
    title: "GameZtudio | Checkout",
    description: "Place your order quickly and securely.",
  },
  login: {
    title: "Login to GameZtudio",
    description: "Sign in to manage your orders and profile.",
  },
  signup: {
    title: "Join GameZtudio",
    description: "Create your account for the best gaming deals.",
  },
  productList: {
  title: "All Gaming Products | GameZtudio",
  description: "Discover the best deals on gaming consoles, CDs, and accessories. Shop now from GameZtudio’s complete product range.",
},
  profile: {
    title: "My Profile | GameZtudio",
    description: "Manage your account, address and preferences.",
  },
  orders: {
    title: "My Orders | GameZtudio",
    description: "Track all your GameZtudio orders and history here.",
  },
  tracking: {
    title: "Order Tracking | GameZtudio",
    description: "Track your shipment in real-time.",
  },
  forgotPassword: {
    title: "Forgot Password | GameZtudio",
    description: "Reset your password securely with your registered email.",
  },
  resetPassword: {
    title: "Reset Password | GameZtudio",
    description: "Choose a new password to access your account.",
  },
  terms: {
    title: "Terms & Conditions | GameZtudio",
    description: "Read our terms and conditions before using our services.",
  },
  privacy: {
    title: "Privacy Policy | GameZtudio",
    description: "Learn how we protect your data and privacy.",
  },
};
